import { render } from "./GameOverModal.vue?vue&type=template&id=39734b86&scoped=true"
import script from "./GameOverModal.vue?vue&type=script&lang=js"
export * from "./GameOverModal.vue?vue&type=script&lang=js"

import "./GameOverModal.vue?vue&type=style&index=0&id=39734b86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39734b86"

export default script